export const fcwp_table = function() {
    document.getElementById('app').arrive("figure.fcwp-table table thead tr", prepareTable);
    document.getElementById('app').arrive("table.fcwp-table tr.table-header", prepareTable);

    
    function prepareTable() {
        var col_items = getHeaderItems(this);
        if (col_items === null) return;

        var col_names = [];
        var text;
        for (var col of col_items) {
            text = col.textContent.length > 12 ? col.textContent.substr(0, 12) + '...' : col.textContent;
            col_names.push(col.textContent);
        }

        var rows = getTableRows(this);

        for (var row of rows) {
            setCellsBefore(row, col_names);
        }
    }

    function getTableRows(header_row) {
        var table = header_row.closest('table');
        var tbody = table.getElementsByTagName('tbody');
        if (tbody.length == 0) {
            return table.getElementsByTagName('tr');
        }
        return tbody.item(0).getElementsByTagName('tr');
    }

    function getHeaderItems(row) {
        var header_th = row.getElementsByTagName('th');
        var header_tr = row.getElementsByTagName('td');
        if (header_th.length > 0) return header_th;
        if (header_tr.length > 0) return header_tr;
        return null;
    }

    function setCellsBefore(row, col_names) {
        var cells = row.getElementsByTagName('td');
        for (var i = 0; i < cells.length; i++) {
            if (col_names[i]) {
                cells[i].setAttribute('before_content', col_names[i]);
                cells[i].classList.add('befored');
            }
        }
    }
}